import ApiHelper from '../../ApiHelper';
import API_ENDPOINTS from '../../endpoints';

const CustomCertificatesHelper = {
  uploadExcel: function (file) {
    const formData = new FormData();
    formData.append('file', file);
    return ApiHelper.upload(API_ENDPOINTS.ADMIN.CUSTOM_CERTIFICATES.UPLOAD, formData);
  },

  getJobStatus: function (jobId) {
    return ApiHelper.get(API_ENDPOINTS.ADMIN.CUSTOM_CERTIFICATES.JOB_STATUS(jobId));
  },

  getJobsList: function () {
    return ApiHelper.get(API_ENDPOINTS.ADMIN.CUSTOM_CERTIFICATES.JOBS_LIST);
  },

  getDownloadUrl: function (jobId) {
    return ApiHelper.get(API_ENDPOINTS.ADMIN.CUSTOM_CERTIFICATES.JOB_DOWNLOAD(jobId));
  },
};

export default CustomCertificatesHelper;
